import {
  DEVICE_PASSWORD_SETUP_ADD_REQUEST,
  DEVICE_PASSWORD_SETUP_ADD_REQUEST_FAILURE,
  DEVICE_PASSWORD_SETUP_ADD_REQUEST_SUCCESS,
  DEVICE_PASSWORD_SETUP_CLEAN_REQUEST,
  DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST,
  DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_FAILURE,
  DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_SUCCESS,
  DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST,
  DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_FAILURE,
  DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_SUCCESS,
  DEVICE_PASSWORD_SETUP_FETCH_REQUEST,
  DEVICE_PASSWORD_SETUP_FETCH_REQUEST_FAILURE,
  DEVICE_PASSWORD_SETUP_FETCH_REQUEST_SUCCESS,
  DEVICE_PASSWORD_SETUP_UPDATE_REQUEST,
  DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_FAILURE,
  DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_SUCCESS,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const DRAFT_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const DRAFT_DETAILS_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const devicePasswordSetupReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DEVICE_PASSWORD_SETUP_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case DEVICE_PASSWORD_SETUP_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case DEVICE_PASSWORD_SETUP_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case DEVICE_PASSWORD_SETUP_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

const devicePasswordSetupDraftReducer = (state, action) => {
  state = state || DRAFT_INITIAL_STATE;

  switch (action.type) {
    case DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST:
    case DEVICE_PASSWORD_SETUP_ADD_REQUEST:
    case DEVICE_PASSWORD_SETUP_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_SUCCESS:
    case DEVICE_PASSWORD_SETUP_ADD_REQUEST_SUCCESS:
    case DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case DEVICE_PASSWORD_SETUP_DRAFT_FETCH_REQUEST_FAILURE:
    case DEVICE_PASSWORD_SETUP_ADD_REQUEST_FAILURE:
    case DEVICE_PASSWORD_SETUP_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case DEVICE_PASSWORD_SETUP_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};
const devicePasswordSetupDraftDetailsReducer = (state, action) => {
  state = state || DRAFT_DETAILS_INITIAL_STATE;

  switch (action.type) {
    case DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case DEVICE_PASSWORD_SETUP_DRAFT_DETAILS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case DEVICE_PASSWORD_SETUP_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

export {
  devicePasswordSetupReducer,
  devicePasswordSetupDraftReducer,
  devicePasswordSetupDraftDetailsReducer,
};
